import { Box, Flex, Skeleton, VStack, Text } from '@chakra-ui/react';

import { CustomText } from '@components/Custom-text';
import { TimelineData } from '@data-types/generic';

interface ReusableTimelineProps {
    title: string;
    iconSrc: any;
    iconBg: string;
    items: TimelineData[];
    isLoading: boolean;
}

const TimelineSection = ({ title, iconSrc, iconBg, items, isLoading }: ReusableTimelineProps) => (
    <Box p={{ base: 4, md: 6 }} borderWidth="1px" borderRadius="md" width="100%">
        <Flex align="center" gap={3} mb={6}>
            <Flex
                width="28px"
                height="28px"
                bgColor={iconBg}
                justifyContent="center"
                alignItems="center"
                borderRadius="4px"
                flexShrink={0}
            >
                <img src={iconSrc.src} alt="icon" width={20} height={20} />
            </Flex>
            <Text
                color="titleText"
                fontSize="16px"
                fontWeight={500}
                fontFamily="Fira Sans"
                lineHeight={1.2}
            >
                {title}
            </Text>
        </Flex>

        <VStack align="start" spacing={0} position="relative" width="100%">
            {isLoading ? (
                <>
                    <Skeleton height="60px" width="100%" />
                    <Skeleton height="60px" width="100%" />
                </>
            ) : (
                items.map((item, index) => (
                    <Flex
                        key={index}
                        gap={{ base: '8px', md: '14px' }}
                        width="100%"
                        flexDirection="row"
                        mb={0}
                    >
                        <Box mb={{ base: 1, md: 0 }} width="80px">
                            <CustomText size="sm" weight={400} color="subText">
                                {item.timeFrame}
                            </CustomText>
                        </Box>

                        <Box display="flex" flexDirection="column" alignItems="center" mb={0}>
                            <Box
                                width="10px"
                                height="10px"
                                bg="primary.light"
                                borderRadius="full"
                                zIndex={1}
                            />
                            <Box
                                height="100%"
                                borderLeft={
                                    index !== 0 ? `2px dotted #A3BAFE` : `2px solid #A3BAFE`
                                }
                            />
                        </Box>

                        <Box
                            flex="1"
                            display="flex"
                            flexDirection="column"
                            gap="2px"
                            mb={index !== items.length - 1 ? 6 : 0}
                        >
                            <Text
                                color="mainText"
                                fontSize={{ base: '15px', md: '16px' }}
                                fontWeight={400}
                                lineHeight="24px"
                            >
                                {item.heading}
                            </Text>
                            <Text
                                fontSize="14px"
                                color="subText"
                                fontWeight={400}
                                lineHeight="20px"
                            >
                                {item.subHeading}
                            </Text>
                            {item.description && (
                                <Text
                                    fontSize="14px"
                                    color="mainText"
                                    fontWeight={400}
                                    lineHeight="20px"
                                    mt={1}
                                >
                                    {item.description}
                                </Text>
                            )}
                        </Box>
                    </Flex>
                ))
            )}
        </VStack>
    </Box>
);
export default TimelineSection;
